<div (click)="toggleText()" class="text-container">
  {{ displayText }}
  <span *ngIf="isTruncated">...</span>
</div>
